import "./style.css";
import Modal from "react-bootstrap/Modal";
import { apiCity, apiState } from "../../../api/stateAndCity";
import { useEffect, useState } from "react";
import Tippy from "@tippyjs/react";
import moment from "moment";

function CompanyViews(props) {
  const [stateValue, setStateValue] = useState([]);
  const [city, setCity] = useState([]);

  async function getStateAndCity() {
    await apiState().then((result) => setStateValue(result.data.data.list));
    await apiCity().then((result) => setCity(result?.data?.data.list));
  }

  useEffect(function () {
    getStateAndCity();
  }, []);

  console.log(" props.id?.expiry_date ", props.id);

  const maskApiKey = (key) => {
    if (!key) return "N/A";
    if (key.length <= 4) return "*****" + key;
    return "*****" + key.slice(-4);
  };

  return (
    <>
      <Modal.Header closeButton className="modal-header-custom">
        <Modal.Title id="modalhead" className="d-flex align-items-center gap-2">
          <span>👁️</span> View Company Details
        </Modal.Title>
      </Modal.Header>
      <div
        className="container-fluid p-3"
        id="buyerAdd"
        style={{ maxHeight: "80vh", overflowY: "auto" }}
      >
        {/* Section 1: General Details */}
        <div className="company-section-card">
          <div className="company-section-header">
            <span>📋</span> General Information
            <span className="company-section-badge">Basic</span>
          </div>
          <div className="row g-2">
            <div className="col-lg-3 col-md-6">
              <label htmlFor="comp_name">Company Name</label>
              <input
                disabled
                type="text"
                className="form-control bg-white"
                id="comp_name"
                value={props.id?.comp_name || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="comp_address">Company Address</label>
              <input
                disabled
                type="text"
                className="form-control bg-white"
                id="comp_address"
                value={props.id?.comp_address || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="state_id">State</label>
              <input
                disabled
                type="text"
                className="form-control bg-white"
                value={
                  stateValue?.find(
                    (el) => el.state_id === props.id?.comp_state_id,
                  )?.name || "N/A"
                }
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="city_id">City</label>
              <input
                disabled
                type="text"
                className="form-control bg-white"
                value={
                  city?.find((el) => el.city_id === props.id?.comp_city_id)
                    ?.city || "N/A"
                }
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="comp_pincode">Pincode</label>
              <input
                disabled
                type="text"
                className="form-control bg-white"
                id="comp_pincode"
                value={props.id?.comp_pincode || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="user_limit">User Limit</label>
              <input
                disabled
                type="text"
                className="form-control bg-white"
                id="user_limit"
                value={props.id?.user_limit || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="expiry_date">Expiry Date</label>
              <input
                type="text"
                disabled
                className="form-control bg-white"
                id="expiry_date"
                value={
                  props.id?.expiry_date
                    ? moment(props.id?.expiry_date).format("DD-MM-YY")
                    : "N/A"
                }
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="display_qty">Display Qty</label>
              <input
                disabled
                type="text"
                className="form-control bg-white"
                id="display_qty"
                value={props.id?.display_qty || "N/A"}
              />
            </div>
          </div>
        </div>

        {/* Section 2: Challan Settings */}
        <div className="company-section-card">
          <div className="company-section-header">
            <span>📄</span> Challan Settings
            <span className="company-section-badge">Sales / Challan</span>
          </div>
          <div className="row g-2">
            <div className="col-lg-3 col-md-6">
              <label htmlFor="tally_godown">Tally Godown (Challan)</label>
              <input
                disabled
                type="text"
                className="form-control bg-white"
                id="tally_godown"
                value={props.id?.tally_godown || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="voucher_type">Voucher Type (Challan)</label>
              <input
                disabled
                type="text"
                className="form-control bg-white"
                id="voucher_type"
                value={props.id?.voucher_type || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="sales_ledger">Ledger (Challan)</label>
              <input
                disabled
                type="text"
                className="form-control bg-white"
                id="sales_ledger"
                value={props.id?.sales_ledger || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="vat_ledger">Vat Ledger (Challan)</label>
              <input
                type="text"
                className="form-control bg-white"
                id="vat_ledger"
                disabled
                value={props.id?.vat_ledger || "N/A"}
              />
            </div>
          </div>
        </div>

        {/* Section 3: Purchase Settings */}
        <div className="company-section-card">
          <div className="company-section-header">
            <span>🛒</span> Purchase Settings
            <span className="company-section-badge">Purchase</span>
          </div>
          <div className="row g-2">
            <div className="col-lg-3 col-md-6">
              <label htmlFor="purchase_godown">Tally Godown (Purchase)</label>
              <input
                type="text"
                className="form-control bg-white"
                id="purchase_godown"
                disabled
                value={props.id?.purchase_godown || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="purchase_voucher_type">
                Voucher Type (Purchase)
              </label>
              <input
                type="text"
                className="form-control bg-white"
                id="purchase_voucher_type"
                disabled
                value={props.id?.purchase_voucher_type || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="purchase_ledger">Ledger (Purchase)</label>
              <input
                type="text"
                className="form-control bg-white"
                id="purchase_ledger"
                disabled
                value={props.id?.purchase_ledger || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="purchase_vat_ledger">Vat Ledger (Purchase)</label>
              <input
                type="text"
                className="form-control bg-white"
                id="purchase_vat_ledger"
                disabled
                value={props.id?.purchase_vat_ledger || "N/A"}
              />
            </div>
          </div>
        </div>

        {/* Section 4: Challan Return Settings */}
        <div className="company-section-card">
          <div className="company-section-header">
            <span>🔄</span> Challan Return Settings
            <span className="company-section-badge">Return</span>
          </div>
          <div className="row g-2">
            <div className="col-lg-3 col-md-6">
              <label htmlFor="credit_note_godown">
                Tally Godown (Challan Return)
              </label>
              <input
                type="text"
                className="form-control bg-white"
                id="credit_note_godown"
                disabled
                value={props.id?.credit_note_godown || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="credit_note_voucher_type">
                Voucher Type (Challan Return)
              </label>
              <input
                type="text"
                className="form-control bg-white"
                id="credit_note_voucher_type"
                disabled
                value={props.id?.credit_note_voucher_type || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="credit_note_ledger">
                Ledger (Challan Return)
              </label>
              <input
                type="text"
                className="form-control bg-white"
                id="credit_note_ledger"
                disabled
                value={props.id?.credit_note_ledger || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="cash_ledger">Cash Ledger</label>
              <input
                type="text"
                className="form-control bg-white"
                id="cash_ledger"
                disabled
                value={props.id?.cash_ledger || "N/A"}
              />
            </div>
          </div>
        </div>

        {/* Section 5: Other Vouchers & Accounting */}
        <div className="company-section-card">
          <div className="company-section-header">
            <span>📊</span> Other Vouchers & Accounting
            <span className="company-section-badge">Accounts</span>
          </div>
          <div className="row g-2">
            <div className="col-lg-3 col-md-6">
              <label htmlFor="expense_voucher_type">Expense Voucher Type</label>
              <input
                type="text"
                className="form-control bg-white"
                id="expense_voucher_type"
                disabled
                value={props.id?.expense_voucher_type || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="income_voucher_type">Income Voucher Type</label>
              <input
                type="text"
                className="form-control bg-white"
                id="income_voucher_type"
                disabled
                value={props.id?.income_voucher_type || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="stock_voucher_type">Stock Voucher Type</label>
              <input
                type="text"
                className="form-control bg-white"
                id="stock_voucher_type"
                disabled
                value={props.id?.stock_voucher_type || "N/A"}
              />
            </div>

            <div className="col-lg-3 col-md-6">
              <label htmlFor="roundoff_ledger">Roundoff Ledger</label>
              <input
                type="text"
                className="form-control bg-white"
                id="roundoff_ledger"
                disabled
                value={props.id?.roundoff_ledger || "N/A"}
              />
            </div>
          </div>
        </div>

        {/* Section 6: Configuration & Permissions */}
        <div className="company-section-card">
          <div className="company-section-header">
            <span>⚙️</span> Configuration & Permissions
            <span className="company-section-badge">Settings</span>
          </div>
          <div className="row g-2">
            <div className="col-lg-4 col-md-6">
              <label htmlFor="access_code_permission">
                Access Code Permission
              </label>
              <input
                disabled
                type="text"
                className="form-control bg-white"
                value={props.id?.access_code_permission == 1 ? "Yes" : "No"}
              />
            </div>

            <div className="col-lg-4 col-md-6">
              <label
                htmlFor="is_cashier_report"
                className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
              >
                Cashier Wise Report
                <Tippy
                  content="Cash payment report cashier wise"
                  trigger="mouseenter"
                >
                  <span className="text-primary" style={{ cursor: "pointer" }}>
                    ℹ️
                  </span>
                </Tippy>
              </label>
              <div className="pt-1">
                {props?.id?.is_cashier_report == 1 ? (
                  <span className="badge bg-success px-3 py-2">Yes</span>
                ) : (
                  <span className="badge bg-secondary px-3 py-2">No</span>
                )}
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <label
                htmlFor="is_erp_integrated"
                className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
              >
                ERP Integration
              </label>
              <div className="pt-1">
                {props?.id?.is_erp_integrated == 1 ? (
                  <span className="badge bg-success px-3 py-2">Yes</span>
                ) : (
                  <span className="badge bg-secondary px-3 py-2">No</span>
                )}
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <label
                htmlFor="is_multi_voucher"
                className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
              >
                Multi Challan Voucher
              </label>
              <div className="pt-1">
                {props?.id?.is_multi_voucher == 1 ? (
                  <span className="badge bg-success px-3 py-2">Yes</span>
                ) : (
                  <span className="badge bg-secondary px-3 py-2">No</span>
                )}
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <label
                htmlFor="is_multi_purchase"
                className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
              >
                Multi Purchase Voucher
              </label>
              <div className="pt-1">
                {props?.id?.is_multi_purchase == 1 ? (
                  <span className="badge bg-success px-3 py-2">Yes</span>
                ) : (
                  <span className="badge bg-secondary px-3 py-2">No</span>
                )}
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <label
                htmlFor="is_purchase_voucher_no"
                className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
              >
                Purchase Voucher No Required
              </label>
              <div className="pt-1">
                {props?.id?.is_purchase_voucher_no == 1 ? (
                  <span className="badge bg-success px-3 py-2">Yes</span>
                ) : (
                  <span className="badge bg-secondary px-3 py-2">No</span>
                )}
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <label
                htmlFor="mpos_integration"
                className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
              >
                MPOS Integration
              </label>
              <div className="pt-1">
                {props?.id?.mpos_integration == 1 ? (
                  <span className="badge bg-success px-3 py-2">Yes</span>
                ) : (
                  <span className="badge bg-secondary px-3 py-2">No</span>
                )}
              </div>
            </div>

            {props?.id?.mpos_integration == 1 && (
              <>
                <div className="col-lg-4 col-md-6">
                  <label
                    htmlFor="is_efris"
                    className="form-label fw-semibold d-flex align-items-center gap-2 mb-1"
                  >
                    Direct Send to EFRIS
                  </label>
                  <div className="pt-1">
                    {props?.id?.is_efris == 1 ? (
                      <span className="badge bg-success px-3 py-2">Yes</span>
                    ) : (
                      <span className="badge bg-secondary px-3 py-2">No</span>
                    )}
                  </div>
                </div>

                <div className="col-lg-4 col-md-6">
                  <label htmlFor="mpos_erp_api_key">MPOS ERP API Key</label>
                  <input
                    disabled
                    type="text"
                    className="form-control bg-white fw-bold tracking-wider"
                    value={maskApiKey(
                      props.id?.mpos_erp_api_key ||
                        props.id?.mpos_api_key ||
                        props.id?.api_key,
                    )}
                  />
                </div>

                <div className="col-lg-4 col-md-6">
                  <label htmlFor="mpos_api_key_non_erp">
                    MPOS Non-ERP API Key
                  </label>
                  <input
                    disabled
                    type="text"
                    className="form-control bg-white fw-bold tracking-wider"
                    value={maskApiKey(
                      props.id?.mpos_api_key_non_erp ||
                        props.id?.mpos_non_erp_api_key,
                    )}
                  />
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <Modal.Footer>
        <button className="btn btn-outline-secondary" onClick={props.hide}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}

export default CompanyViews;
